import { ConsultantsQuerySocialWorkerFormInput, SelectType } from "@graphql";

export const socionomInitialValues: ConsultantsQuerySocialWorkerFormInput = {
  options: {
    type: SelectType.ANY,
    value: []
  },
  specializations: {
    type: SelectType.ANY,
    value: []
  },
  experienceMinYears: "",
  educations: []
};

export const years = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
